<template>
  <a-modal
      :title="title"
      :visible="visible"
      :width="isMobile() ? '100%': '80%'"
      :dialog-style="isMobile() ? { top: '0', padding: '0', margin:'0', 'max-width': 'calc(100vw)'} : {}"
      @cancel="handleCancel"
      :maskClosable="false"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel" style="margin-left: 8px">
        关闭
      </a-button>
      <a-button @click="handleOk()" type="primary" style="margin-left: 8px">
        确定
      </a-button>
    </template>
    <a-alert banner closable>
      <span slot="message">温馨提示：<br/>①该软件系统仅适用于签证预约服务，并不能保证100%预约成功。系统账号密码请妥善保管，避免客户信息泄露。<br/>②如申请人的签证申请曾经被拒签，请务必更新最新AA码后，方可预约新的签证面谈时间。请认真填写并核对申请人信息，以免影响预约进度。<br/>③录入系统信息必须与使馆录入一致。</span>
    </a-alert>
    <a-form-model ref="targetForm" :model="form" :rules="rules" :label-col="{span: 5}" :wrapper-col="{span: 18}"
                  style="margin-top: 20px">
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="账号取消过" prop="canceled">
            <a-radio-group v-model="form.canceled">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="姓名" prop="name">
            <a-input v-model="form.name"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <template v-if="form.canceled === 'No' || !form.canceled">
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="账号" prop="account">
              <a-input v-model="form.account"/>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="密码" prop="password">
              <a-input v-model="form.password"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="安全问题1" prop="question1">
              <a-select v-model="form.question1">
                <a-select-option value="您母亲的姓氏是什么?">您母亲的姓氏是什么?</a-select-option>
                <a-select-option value="您的第一个/目前/最喜欢的宠物名称是什么?">您的第一个/目前/最喜欢的宠物名称是什么?
                </a-select-option>
                <a-select-option value="您的第一辆汽车是什么车?">您的第一辆汽车是什么车?</a-select-option>
                <a-select-option value="您在哪所小学上学?">您在哪所小学上学?</a-select-option>
                <a-select-option value="您出生的地方/城市叫什么名字?">您出生的地方/城市叫什么名字?</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="答案1" prop="answer1">
              <a-input v-model="form.answer1"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="安全问题2" prop="question2">
              <a-select v-model="form.question2">
                <a-select-option value="您成长的道路/街道叫称是什么?">您成长的道路/街道叫称是什么?</a-select-option>
                <a-select-option value="您最不喜欢的食物是什么?">您最不喜欢的食物是什么?</a-select-option>
                <a-select-option value="您的第一份工作是在哪家公司?">您的第一份工作是在哪家公司?</a-select-option>
                <a-select-option value="您最喜欢的食物是什么?">您最喜欢的食物是什么?</a-select-option>
                <a-select-option value="您在哪所高中求学?">您在哪所高中求学?</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="答案2" prop="answer2">
              <a-input v-model="form.answer2"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="安全问题3" prop="question3">
              <a-select v-model="form.question3">
                <a-select-option value="您在哪里遇见您的配偶?">您在哪里遇见您的配偶?</a-select-option>
                <a-select-option value="您的兄弟姐妹的中间名字是什么?">您的兄弟姐妹的中间名字是什么?</a-select-option>
                <a-select-option value="谁是您儿时的英雄?">谁是您儿时的英雄?</a-select-option>
                <a-select-option value="您的第一份工作在哪个城市或地方?">您的第一份工作在哪个城市或地方?
                </a-select-option>
                <a-select-option value="您申请但未就读的大学是哪所大学?">您申请但未就读的大学是哪所大学?
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="答案3" prop="answer3">
              <a-input v-model="form.answer3"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="签证领区" prop="area">
              <a-select v-model="form.area">
                <a-select-option value="BEIJING">BEIJING(北京)</a-select-option>
                <a-select-option value="SHANGHAI">SHANGHAI(上海)</a-select-option>
                <a-select-option value="GUANGZHOU">GUANGZHOU(广州)</a-select-option>
                <a-select-option value="SHENYANG">SHENYANG(沈阳)</a-select-option>
                <a-select-option value="WUHAN">WUHAN(武汉)</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="签证类型" prop="type">
              <a-select v-model="form.type">
                <a-select-option value="B1/B2">B1/B2</a-select-option>
                <a-select-option value="B2">B2</a-select-option>
                <a-select-option value="B1">B1</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="预约日期范围" prop="applicantDate">
              <a-range-picker style="width: 100%" valueFormat="YYYY-MM-DD" v-model="form.applicantDate"/>
            </a-form-model-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="12">
            <a-form-model-item label="备注" prop="remark">
              <a-input v-model="form.remark"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
    </a-form-model>
    <insert-modal ref="insertModal" @complete="handleComplete($event)"></insert-modal>
  </a-modal>
</template>

<script>

import moment from 'moment';
import {HttpMixins} from "@/mixins/http-mixins";
import InsertModal from "@/components/usApplicant/InsertModal.vue";
import {ResponsiveMixins} from "@/mixins/responsive-mixins";

const pattern = {
  numberOrChinaOrEnglish: /^([\u4E00-\u9FA5\w\- ]+)$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  number: /^([0-9]*)$/,
  capitalNumber: /^([A-Za-z0-9]*)$/,
  english: /^[A-Za-z]+( [A-Za-z]+)*$/,
}

export default {
  name: "CreateModal",
  mixins: [HttpMixins, ResponsiveMixins],
  components: {
    InsertModal,
  },
  data() {
    return {
      title: '',
      visible: false,
      username: localStorage.getItem('username'),
      form: {},
      rules: {
        canceled: [
          {required: true, message: '必填!'},
        ],
        name: [
          {required: true, pattern: pattern.numberOrChinaOrEnglish, message: '请输入名称!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'},
          {validator: this.filterSpecial}
        ],
        account: [
          {required: true, message: '必填!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码!'},
          {min: 6, max: 256, message: '至少6位,长度不超过256个字符', trigger: 'blur'}
        ],
        question1: [
          {required: true, message: '必填!'},
        ],
        question2: [
          {required: true, message: '必填!'},
        ],
        question3: [
          {required: true, message: '必填!'},
        ],
        answer1: [
          {required: true, pattern: pattern.capitalNumber, message: '请输入答案!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        answer2: [
          {required: true, pattern: pattern.capitalNumber, message: '请输入答案!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        answer3: [
          {required: true, pattern: pattern.capitalNumber, message: '请输入答案!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请输入签证类型!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        area: [
          {required: true, message: '请输入签证领区!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'}
        ],
        applicantDate: [
          {required: true, message: '请输入预约开始日期!'},
        ],
        remark: [],
      },
      url: {
        add: window._CONFIG['domainURL'] + "/usAppointment",
        edit: window._CONFIG['domainURL'] + "/usAppointment",
      }
    }
  },
  methods: {
    moment,
    show(title, record) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.targetForm.resetFields();

        if (title === '编辑') {
          this.title = title;
          let data = Object.assign({}, record);
          data.applicantDate = [record.applicantStart, record.applicantEnd];
          data.canceled = 'No'
          this.form = Object.assign({}, data);
        }
        if (title === '新增') {
          this.title = title;
          record.canceled = 'No'
          this.form = Object.assign({}, record);
        }
      })
    },
    handleComplete(data) {
      this.form = Object.assign({}, data);
    },
    handleOk() {
      let that = this;
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          if (that.form.applicantDate) {
            that.form.applicantStart = that.form.applicantDate[0];
            that.form.applicantEnd = that.form.applicantDate[1];
          }
          if (that.title === '新增') {
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success('已提交');
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.post(that.url.add, that.form, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
          if (that.title === '编辑') {
            const handleSuccess = (res) => {
              if (res) {
                let response = res.data;
                if (response.code === 200) {
                  that.$message.success('已提交');
                  that.$emit('ok');
                  that.handleCancel();
                } else {
                  that.$message.error(response.msg);
                }
              }
            }
            that.$axios.put(that.url.edit, that.form, {headers: that.headers})
                .then(handleSuccess)
                .catch((error) => that.catchError(error).then(handleSuccess));
          }
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    filterSpecial(rule, value, callback) {
      const pattern = new RegExp("[.`~!@#$^&*=|{}':;',\\[\\]<>《》/?~！@#￥……&*|{}【】‘；：”“'。，、？'']");
      if (pattern.test(value)) {
        callback('禁止输入特殊字符')
      } else {
        callback()
      }
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>
